module.exports = __webpack_public_path__ + "media/images/brand/200/MARQUESBRANDINGCO LOGO X-d0191931dd3935c5396ba08984657ec1.png";